import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./scss/index.scss";
import { AvatarPicker, Button, Checkbox, Message } from "@components/atoms";
import { InputFile, InputSelect, TextareaField, TextField } from "@components/molecules";
import { useUserDetails } from "@sdk/react";
import { usePrismicLayout } from "@temp/@prismic/templates/PrismicLayout/hooks/usePrismicLayout";
import { Overlay, OverlayTheme, OverlayType } from "@temp/components";
import classNames from "classnames";
import { Formik } from "formik";
import { ReviewAvatarEnum } from "gqlTypes/globalTypes";
import { RichText } from "prismic-reactjs";
import React, { useState } from "react";
import { useIntl } from "react-intl";
import { Link } from "react-router-dom";
import ReactSVG from "react-svg";
import { RudderAnalytics } from "../../../app/analitics";
import starImg from "../../../images/red-star.svg";
import closeImg from "../../../images/x.svg";
import { commonMessages, validationCommonMsg } from "../../../intl";
import { TypedCategoriesQuery, TypedCreateReviewMutation } from "./queries";
export function AddReview(_ref) {
  var overlay = _ref.overlay;
  var intl = useIntl();

  var _usePrismicLayout = usePrismicLayout(),
      layout = _usePrismicLayout.layout;

  var hide = overlay.hide;

  var _useUserDetails = useUserDetails(),
      user = _useUserDetails.data;

  var stars = new Array(5).fill("");

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      accepted = _useState2[0],
      setAccepted = _useState2[1];

  var _useState3 = useState(5),
      _useState4 = _slicedToArray(_useState3, 2),
      rateSelected = _useState4[0],
      setRateSelected = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      submitError = _useState6[0],
      setSubmitError = _useState6[1];

  return React.createElement(Overlay, {
    context: overlay
  }, React.createElement(TypedCreateReviewMutation, {
    onError: setSubmitError,
    onCompleted: function onCompleted(data) {
      if (!data.reviewCreate.errors.length) {
        hide();
      } else {
        console.error(data.reviewCreate.errors);
      }
    }
  }, function (createReview, _ref2) {
    var loading = _ref2.loading,
        data = _ref2.data;
    var fieldErrors = {};

    if (data && data.reviewCreate.errors.length) {
      data.reviewCreate.errors.forEach(function (_ref3) {
        var field = _ref3.field,
            message = _ref3.message;

        if (field && message) {
          fieldErrors[field] = fieldErrors[field] ? [].concat(_toConsumableArray(fieldErrors[field]), [{
            message: message
          }]) : [{
            message: message
          }];
        }
      });
    }

    return React.createElement(Formik, {
      initialValues: {
        avatar: ReviewAvatarEnum.AVATAR_0,
        category: undefined,
        description: "",
        email: "",
        fullName: "",
        images: [],
        title: ""
      },
      validate: function validate(values) {
        var errors = {};

        if (!values.fullName) {
          errors.fullName = intl.formatMessage(validationCommonMsg.required);
        }

        if (!values.title) {
          errors.title = intl.formatMessage(validationCommonMsg.required);
        }

        if (!values.email) {
          errors.email = intl.formatMessage(validationCommonMsg.required);
        }

        if (!values.description) {
          errors.description = intl.formatMessage(validationCommonMsg.required);
        }

        if (!values.category) {
          errors.category = intl.formatMessage(validationCommonMsg.required);
        }

        return errors;
      },
      onSubmit:
      /*#__PURE__*/
      function () {
        var _ref5 = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee(values, _ref4) {
          var _values$category, _values$category2;

          var setSubmitting;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  setSubmitting = _ref4.setSubmitting;
                  _context.next = 3;
                  return createReview({
                    variables: {
                      input: {
                        avatar: values.avatar,
                        category: (_values$category = values.category) === null || _values$category === void 0 ? void 0 : _values$category.value,
                        description: values.description,
                        email: values.email,
                        fullName: values.fullName,
                        images: _toConsumableArray(values.images).map(function (image) {
                          return {
                            image: image
                          };
                        }),
                        rating: rateSelected,
                        title: values.title
                      }
                    }
                  });

                case 3:
                  // @analitics
                  RudderAnalytics.track("Product Reviewed", {
                    product_id: (_values$category2 = values.category) === null || _values$category2 === void 0 ? void 0 : _values$category2.value,
                    rating: rateSelected,
                    review_body: values.description
                  }, {
                    context: {
                      traits: {
                        email: values.email,
                        fullName: values.fullName
                      }
                    }
                  });
                  setSubmitting(false);

                case 5:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x, _x2) {
          return _ref5.apply(this, arguments);
        };
      }()
    }, function (_ref6) {
      var handleChange = _ref6.handleChange,
          handleSubmit = _ref6.handleSubmit,
          handleBlur = _ref6.handleBlur,
          values = _ref6.values,
          touched = _ref6.touched,
          errors = _ref6.errors,
          isSubmitting = _ref6.isSubmitting,
          setFieldValue = _ref6.setFieldValue;
      return React.createElement("div", {
        className: "review-popup"
      }, submitError && React.createElement(Message, {
        title: submitError.message,
        status: "error",
        onClick: function onClick() {
          return setSubmitError(null);
        }
      }), React.createElement(ReactSVG, {
        path: closeImg,
        onClick: hide,
        className: "review-popup__close"
      }), React.createElement("div", {
        className: "review-popup__header"
      }, React.createElement("div", {
        className: "review-popup__header-avatar"
      }, React.createElement(AvatarPicker, {
        value: values.avatar,
        onChange: function onChange(value) {
          return setFieldValue("avatar", value);
        }
      })), React.createElement("h2", {
        className: "review-popup__header-title"
      }, intl.formatMessage(_defineProperty({
        defaultMessage: "Add a review",
        "id": "components.OverlayManager.AddReview.AddReview.1899271783"
      }, "id", "components.OverlayManager.AddReview.AddReview.1899271783"))), !user && React.createElement("div", {
        className: "review-popup__header-login"
      }, intl.formatMessage(_defineProperty({
        defaultMessage: "Already have an account?",
        "id": "components.OverlayManager.AddReview.AddReview.3997369764"
      }, "id", "components.OverlayManager.AddReview.AddReview.3997369764")), React.createElement("button", {
        type: "button",
        onClick: function onClick() {
          return overlay.show(OverlayType.login, OverlayTheme.modal);
        }
      }, intl.formatMessage(_defineProperty({
        defaultMessage: "Sign in",
        "id": "components.OverlayManager.AddReview.AddReview.1405865627"
      }, "id", "components.OverlayManager.AddReview.AddReview.1405865627"))), intl.formatMessage(_defineProperty({
        defaultMessage: "or continue as guest.",
        "id": "components.OverlayManager.AddReview.AddReview.3030560766"
      }, "id", "components.OverlayManager.AddReview.AddReview.3030560766")))), React.createElement("div", {
        className: "review-popup__rate"
      }, intl.formatMessage(_defineProperty({
        defaultMessage: "Rate you doors:",
        "id": "components.OverlayManager.AddReview.AddReview.306221317"
      }, "id", "components.OverlayManager.AddReview.AddReview.306221317")), React.createElement("div", {
        className: "review-popup__rate-stars"
      }, stars.map(function (z, i) {
        return React.createElement("button", {
          type: "button",
          key: i,
          onClick: function onClick() {
            return setRateSelected(i + 1);
          },
          className: classNames("review-popup__rate-stars__button", {
            active: i + 1 === rateSelected,
            opacity: i >= rateSelected
          })
        }, React.createElement("img", {
          src: starImg,
          alt: "star"
        }));
      }))), React.createElement("form", {
        onSubmit: handleSubmit
      }, React.createElement("div", {
        className: "form-row"
      }, React.createElement(TextField, {
        name: "fullName",
        label: intl.formatMessage(_defineProperty({
          defaultMessage: "Your name",
          "id": "components.OverlayManager.AddReview.AddReview.2657164037"
        }, "id", "components.OverlayManager.AddReview.AddReview.2657164037")),
        value: values.fullName,
        onBlur: handleBlur,
        onChange: handleChange // required
        ,
        errors: touched.fullName && errors.fullName ? [{
          message: errors.fullName
        }] : undefined || fieldErrors.fullName
      }), React.createElement(TextField, {
        name: "email",
        label: intl.formatMessage(_defineProperty({
          defaultMessage: "Your email address",
          "id": "components.OverlayManager.AddReview.AddReview.1357897190"
        }, "id", "components.OverlayManager.AddReview.AddReview.1357897190")),
        value: values.email,
        onBlur: handleBlur,
        onChange: handleChange // required
        ,
        errors: touched.email && errors.email ? [{
          message: errors.email
        }] : undefined || fieldErrors.email
      })), React.createElement("div", null, React.createElement(TypedCategoriesQuery, null, function (_ref7) {
        var categories = _ref7.data.categories;
        return React.createElement(InputSelect, {
          label: intl.formatMessage(_defineProperty({
            defaultMessage: "Select collection...",
            "id": "components.OverlayManager.AddReview.AddReview.3539415619"
          }, "id", "components.OverlayManager.AddReview.AddReview.3539415619")),
          name: "category",
          value: values.category,
          errors: touched.category && errors.category && typeof errors.category === "string" ? [{
            message: errors.category
          }] : undefined || fieldErrors.category,
          options: categories.edges.map(function (e) {
            return {
              label: e.node.name,
              value: e.node.id
            };
          }),
          onChange: function onChange(value, name) {
            setFieldValue(name, value);
          }
        });
      })), React.createElement(TextField, {
        name: "title",
        label: intl.formatMessage(_defineProperty({
          defaultMessage: "Title",
          "id": "components.OverlayManager.AddReview.AddReview.1124600214"
        }, "id", "components.OverlayManager.AddReview.AddReview.1124600214")),
        value: values.title,
        onBlur: handleBlur,
        onChange: handleChange,
        maxLength: 100 // required
        ,
        errors: touched.title && errors.title ? [{
          message: errors.title
        }] : undefined || fieldErrors.title
      }), React.createElement("div", {
        className: "review-popup__characters-counter"
      }, 100 - values.title.length, intl.formatMessage(_defineProperty({
        defaultMessage: "characters left",
        "id": "components.OverlayManager.AddReview.AddReview.4070937122"
      }, "id", "components.OverlayManager.AddReview.AddReview.4070937122"))), React.createElement("div", null, React.createElement(TextareaField, {
        label: intl.formatMessage(_defineProperty({
          defaultMessage: "Your message...",
          "id": "components.OverlayManager.AddReview.AddReview.189418074"
        }, "id", "components.OverlayManager.AddReview.AddReview.189418074")),
        name: "description",
        value: values.description,
        onBlur: handleBlur,
        onChange: handleChange,
        maxLength: 1200,
        errors: touched.description && errors.description ? [{
          message: errors.description
        }] : undefined || fieldErrors.description
      })), React.createElement("div", {
        className: "review-popup__characters-counter"
      }, 1200 - values.description.length, intl.formatMessage(_defineProperty({
        defaultMessage: "characters left",
        "id": "components.OverlayManager.AddReview.AddReview.4070937122"
      }, "id", "components.OverlayManager.AddReview.AddReview.4070937122"))), React.createElement("div", {
        className: "review-popup__center"
      }, React.createElement("div", {
        className: "review-popup__upload"
      }, React.createElement(InputFile, {
        label: intl.formatMessage(_defineProperty({
          defaultMessage: "Upload photos",
          "id": "components.OverlayManager.AddReview.AddReview.2436333382"
        }, "id", "components.OverlayManager.AddReview.AddReview.2436333382")),
        name: "collection",
        onChange: function onChange(e) {
          var _e$target = e.target,
              files = _e$target.files,
              validity = _e$target.validity;

          if (validity.valid) {
            setFieldValue("images", files);
          }
        },
        onClear: function onClear() {
          return setFieldValue("images", []);
        }
      })), React.createElement("div", {
        className: "review-popup__accepted"
      }, React.createElement(Checkbox, {
        className: "review-popup__accepted-checkbox",
        name: "accepted",
        checked: accepted,
        onChange: function onChange() {
          return setAccepted(function (v) {
            return !v;
          });
        },
        color: "primary"
      }, intl.formatMessage(commonMessages.accept)), React.createElement(Link, {
        to: "#"
      }, intl.formatMessage(commonMessages.termsOfService))), React.createElement("div", {
        className: "review-popup__form__button"
      }, React.createElement(Button, {
        className: "button red",
        type: "submit",
        disabled: isSubmitting || !accepted
      }, intl.formatMessage(_defineProperty({
        defaultMessage: "Send A review",
        "id": "components.OverlayManager.AddReview.AddReview.1007617149"
      }, "id", "components.OverlayManager.AddReview.AddReview.1007617149")))))), React.createElement("div", {
        className: "review-popup__gdrp-text"
      }, (layout === null || layout === void 0 ? void 0 : layout.gdrp_text) && React.createElement(RichText, {
        render: layout.gdrp_text
      })));
    });
  }));
}